import { render, staticRenderFns } from "./PsGroupsDetailDailyItem.vue?vue&type=template&id=8f3e3686&scoped=true&"
import script from "./PsGroupsDetailDailyItem.vue?vue&type=script&lang=js&"
export * from "./PsGroupsDetailDailyItem.vue?vue&type=script&lang=js&"
import style0 from "./PsGroupsDetailDailyItem.vue?vue&type=style&index=0&id=8f3e3686&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f3e3686",
  null
  
)

export default component.exports